import styled from 'styled-components';
import SVG from 'react-inlinesvg';

export const StyledSVG = styled(SVG).attrs({
  width: '40px',
  height: '40px',
  'aria-hidden': true,
})``;
